import { useState } from "react";
import apiPatente from "@/api/Patente";
import { useDialog } from "@/hooks/useDialog";

export const usePatente = () => {
  const [info, setInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { show } = useDialog();

  const getPatente = async (cedulaRuc, captchaToken = null) => {
    setIsLoading(true);

    try {
      setInfo(null);
      const res = await apiPatente.get(cedulaRuc, captchaToken);

      if (typeof res.data.data === "string") {
        show({
          type: "error",
          title: "Ha ocurrido un error",
          message: "Patente no encontrada.",
        });
      } else {
        setInfo(res.data.data);
      }
    } catch (e) {
      if (e.name !== "CanceledError" && e.name !== "AbortError") {
        setInfo(null);

        show({
          type: "error",
          title: "Ha ocurrido un error",
          message:
            e?.response?.data?.msg ??
            "Ocurrió un error al consultar la patente, por favor intente nuevamente",
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  return { info, isLoading, getPatente };
};